import type * as Types from '../../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import { FileFieldsFragmentDoc } from '../../../graphql/gql-fragments/document.graphql';
import { VestingOccasionFieldsFragmentDoc } from '../../../graphql/gql-fragments/warrant-program-participant.graphql';
import { IdentityFieldsFragmentDoc } from '../../../graphql/gql-fragments/identity.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlOptionOverviewQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  offset: Types.Scalars['Int']['input'];
  limit: Types.Scalars['Int']['input'];
  sort: Types.GqlWppSort;
  showSplitAdjusted?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GqlOptionOverviewQuery = { companyStatistics: { issuedOptions: number }, company: { id: string, warrantParticipants: { totalCount: number, models: Array<{ id: string, quantity?: string | null, vestedQuantity: string, vestingStatus: Types.GqlVestingStatus, vestingKind: number, vestingCliffDuration: number, vestingDuration: number, vestingFrequency: number, vestingEndDate?: string | null, wontVestQuantity?: string | null, vestedQuantityOnEndDate?: string | null, vestedPercentage: string, quantityLeft: string, splitFactor: string, vestingExplanationPrimaryLang?: string | null, vestingExplanationSecondaryLang?: string | null, paymentStatus: number, quantityInvalidated?: string | null, comment?: string | null, quantityRepurchased: string, latestAgreementDoc?: { id: string, companyId: string, mimeType: string, filename: string, filesize?: number | null, sha256?: string | null, signedFilesize?: number | null, signedSha256?: string | null, signatureMethod?: Types.GqlDocumentSignatureMethod | null, dirty: boolean, scriveMtime?: string | null, scriveCtime?: string | null, scriveStatus?: Types.GqlScriveDocumentStatus | null, scriveParties?: any | null, scriveTimeoutTime?: string | null, zignedAgreementStatus?: Types.GqlZignedAgreementStatus | null, signAllowedAction: Types.GqlSignAllowedAction, hasSignStatus: boolean, hasThumbnail: boolean, kind: Types.GqlDocSystemTagKind, groupId?: string | null, userTags?: Array<string> | null, genState: Types.GqlDocGenState, uploaded: boolean, reminderSentAt?: string | null, deletable: boolean, softDeletable: boolean, createdAt: string, updatedAt: string, sharedWithShareholders: boolean } | null, vestingOccasions: Array<{ id: string, warrantParticipantId: string, quantity: string, vestingDate?: string | null, descriptionPrimaryLang?: string | null, descriptionSecondaryLang?: string | null, requirementPrimaryLang?: string | null, requirementSecondaryLang?: string | null, sortOrder: number, isValid: boolean, totalVested?: string | null, status: Types.GqlVestingOccasionStatus }>, identity: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string }, optionsRegistration: { id: string, warrantProgram: { id: string, name?: string | null, warrantStartDate?: string | null, warrantKind: Types.GqlWarrantProgramKind, usesStepper: boolean } } }> } } };

export type GqlWppExplainVestingScheduleMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GqlWppExplainVestingScheduleMutation = { wppExplainVestingSchedule: { id: string, vestingExplanationPrimaryLang?: string | null, vestingExplanationSecondaryLang?: string | null } };


export const OptionOverviewDocument = gql`
    query OptionOverview($companyId: ID!, $offset: Int!, $limit: Int!, $sort: WppSort!, $showSplitAdjusted: Boolean) {
  companyStatistics(id: $companyId) {
    issuedOptions
  }
  company(id: $companyId) {
    id
    warrantParticipants(
      offset: $offset
      limit: $limit
      sort: $sort
      showSplitAdjusted: $showSplitAdjusted
    ) {
      totalCount
      models {
        id
        quantity
        vestedQuantity
        vestingStatus
        vestingKind
        vestingCliffDuration
        vestingDuration
        vestingFrequency
        vestingEndDate
        wontVestQuantity
        vestedQuantityOnEndDate
        vestedQuantity
        vestedPercentage
        quantityLeft
        splitFactor
        vestingExplanationPrimaryLang
        vestingExplanationSecondaryLang
        paymentStatus
        quantityInvalidated
        latestAgreementDoc {
          ...FileFields
        }
        comment
        quantityRepurchased
        vestingOccasions {
          ...VestingOccasionFields
        }
        identity {
          ...IdentityFields
        }
        optionsRegistration {
          id
          warrantProgram {
            id
            name
            warrantStartDate
            warrantKind
            usesStepper
          }
        }
      }
    }
  }
}
    ${FileFieldsFragmentDoc}
${VestingOccasionFieldsFragmentDoc}
${IdentityFieldsFragmentDoc}`;

/**
 * __useOptionOverviewQuery__
 *
 * To run a query within a React component, call `useOptionOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptionOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptionOverviewQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      showSplitAdjusted: // value for 'showSplitAdjusted'
 *   },
 * });
 */
export function useOptionOverviewQuery(baseOptions: Apollo.QueryHookOptions<GqlOptionOverviewQuery, GqlOptionOverviewQueryVariables> & ({ variables: GqlOptionOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlOptionOverviewQuery, GqlOptionOverviewQueryVariables>(OptionOverviewDocument, options);
      }
export function useOptionOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlOptionOverviewQuery, GqlOptionOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlOptionOverviewQuery, GqlOptionOverviewQueryVariables>(OptionOverviewDocument, options);
        }
export function useOptionOverviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlOptionOverviewQuery, GqlOptionOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlOptionOverviewQuery, GqlOptionOverviewQueryVariables>(OptionOverviewDocument, options);
        }
export type OptionOverviewQueryHookResult = ReturnType<typeof useOptionOverviewQuery>;
export type OptionOverviewLazyQueryHookResult = ReturnType<typeof useOptionOverviewLazyQuery>;
export type OptionOverviewSuspenseQueryHookResult = ReturnType<typeof useOptionOverviewSuspenseQuery>;
export type OptionOverviewQueryResult = Apollo.QueryResult<GqlOptionOverviewQuery, GqlOptionOverviewQueryVariables>;
export const WppExplainVestingScheduleDocument = gql`
    mutation WppExplainVestingSchedule($id: ID!) {
  wppExplainVestingSchedule(id: $id) {
    id
    vestingExplanationPrimaryLang
    vestingExplanationSecondaryLang
  }
}
    `;
export type GqlWppExplainVestingScheduleMutationFn = Apollo.MutationFunction<GqlWppExplainVestingScheduleMutation, GqlWppExplainVestingScheduleMutationVariables>;

/**
 * __useWppExplainVestingScheduleMutation__
 *
 * To run a mutation, you first call `useWppExplainVestingScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWppExplainVestingScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wppExplainVestingScheduleMutation, { data, loading, error }] = useWppExplainVestingScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWppExplainVestingScheduleMutation(baseOptions?: Apollo.MutationHookOptions<GqlWppExplainVestingScheduleMutation, GqlWppExplainVestingScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlWppExplainVestingScheduleMutation, GqlWppExplainVestingScheduleMutationVariables>(WppExplainVestingScheduleDocument, options);
      }
export type WppExplainVestingScheduleMutationHookResult = ReturnType<typeof useWppExplainVestingScheduleMutation>;
export type WppExplainVestingScheduleMutationResult = Apollo.MutationResult<GqlWppExplainVestingScheduleMutation>;
export type WppExplainVestingScheduleMutationOptions = Apollo.BaseMutationOptions<GqlWppExplainVestingScheduleMutation, GqlWppExplainVestingScheduleMutationVariables>;